import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const UseScrollRestoration = () => {
  const location = useLocation();
  const scrollPositions = useRef({});

  useEffect(() => {
    const handleScroll = () => {
      // Save the scroll position using the location key
      scrollPositions.current[location.key] = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  useEffect(() => {
    // Check if there's a saved position for this route
    const scrollPosition = scrollPositions.current[location.key];
    if (scrollPosition !== undefined) {
      // Restore the previous scroll position
      window.scrollTo(0, scrollPosition);
    } else {
      // No saved position, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

export default UseScrollRestoration;
